export const COLORS = {
    transparent: 'transparent',
    white: '#ffffff',
    titleText: '#23024D',
    descriptionText: '#000427',
    paragraphText: '#000636',
    grayText: '#6B6C83',
    darkGrayText: '#4B4E67',
    buttonBackground: '#23024D',
    purple: '#872AB0',
    tooltip: '#8620B9',
    background: '#5C1283',
    gray: '#E8E8ED',
    lightGray: '#FAFAFB',
    placeholder: '#B3B4C3',
    darkPurple: '#24034F',
    pinkRed: '#FF3461',
    yellow: '#F8D26C',
    green: '#00B796',
    orange: '#FF8F00',
    border: '#E9E6ED',
    blue: '#2E30F0',
};

export const FONT_FAMILY = {
    roboto: 'Roboto, sans-serif',
};

export const Z_INDEX = {
    header: 30,
    accountMenu: 450,
    tooltip: 400,
    modal: 500,
    toast: 600,
};

export enum Breakpoints {
    xs = '480px',
    sm = '768px',
    md = '992px',
    lg = '1200px',
    xl = '1400px',
    xxl = '1600px',
    xxxl = '1800px',
}
